/**
 * 
 * Comprobamos si es null la variable
 */

export const siEsNull = (value: string | null) => {
    try {
        if (value == null) {
            return '';
        } else {
            return value;
        }
    } catch (error) {
          return '';
    }
} 